import styled from 'styled-components';

export const Container = styled.section`
  &.form-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: #fff;
    padding: 16px 20px;
    margin-bottom: 16px;
  }

  .section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h2 {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #21354a;
    }

    .material-icons-outlined {
      font-size: 20px;
    }
  }

  .field-label {
    font-size: 14px;
    font-weight: 500;
    color: #21354a;
  }

  .field-label-actions {
    position: relative;

    > button {
      width: 28px;
      height: 28px;
      border: 0;
      background: transparent;
      color: #6c757d;
      line-height: 1;

      .material-icons-outlined {
        font-size: 18px;
      }
    }
  }

  .field-menu {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 20;
    min-width: 150px;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    padding: 4px 0;

    button {
      border: 0;
      background: transparent;
      text-align: left;
      padding: 6px 12px;
      font-weight: 400;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 6px;

      &:hover {
        background: #f8f9fa;
      }

      .material-icons-outlined {
        font-size: 16px;
      }
    }
  }

  .proposal-conditions-help .material-icons-outlined {
    font-size: 16px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }

  .conditions-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 32px;
  }

  .proposal-conditions-field {
    margin-bottom: 0 !important;
    font-size: 14px;
    font-weight: 500;
    color: #21354a;

    > .small {
      font-size: 14px;
      margin-bottom: 5px;
    }

    input,
    textarea {
      min-height: 38px;
      border: 1px solid #ced4da;
      border-radius: 4px;
      font-weight: 400;
      font-size: 14px;
    }

    &.wide {
      grid-column: 1 / -1;
    }

    &.invalid input {
      border-color: ${(props) => props.theme.$danger};
    }
  }

  .proposal-conditions-suffix {
    display: flex;

    input {
      flex: 1;
      border-radius: 4px 0 0 4px;
    }

    > span {
      border: 1px solid #ced4da;
      border-left: 0;
      background: #e9ecef;
      padding: 7px 10px;
      border-radius: 0 4px 4px 0;
      color: #495057;
      font-weight: 400;
    }
  }

  .proposal-conditions-help {
    display: block;
    color: ${(props) => props.theme.$gray700};

    &.erro {
      color: ${(props) => props.theme.$danger};
    }
  }

  .proposal-conditions-popover {
    max-width: 360px;
    padding: 12px;
    border: 1px solid ${(props) => props.theme.$gray200 || '#eee'};
    border-radius: 4px;
  }
`;
